<div
  class="tw-bg-white tw-m-auto tw-rounded-2xl tw-py-6 tw-px-6 md:!tw-px-8 tw-mx-4 md:!tw-mx-auto tw-mt-6 tw-border-solid tw-border-gray-200"
>
  <div
    class="tw-flex tw-flex-col md:!tw-flex-row tw-justify-between tw-items-start tw-gap-6 md:!tw-gap-8"
  >
    @for (step of steps; track step.title; let i = $index) {
      <div
        class="tw-flex tw-flex-row tw-gap-[16px] tw-items-start tw-w-full md:!tw-w-auto md:!tw-flex-1"
      >
        <rv-badge
          shape="icon"
          class="tw-size-[40px]"
          [color]="step.color"
          [icon]="step.icon"
        />
        <div class="tw-flex tw-flex-col tw-gap-1">
          <span class="tw-font-semibold tw-text-gray-900 tw-text-[15px]">
            {{ step.title }}
          </span>
          <span class="tw-text-gray-500 tw-text-[14px]">{{ step.body }}</span>
        </div>
      </div>
    }
  </div>
</div>
